'use strict';

export default {
    proposals: []
};
